/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function ArrowRetractIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="m34.578 7.531-8.495 8.438h5.434c.813 0 1.5.687 1.5 1.5 0 .875-.687 1.5-1.5 1.5h-8.995c-.874 0-1.5-.625-1.5-1.5v-9c0-.813.626-1.5 1.5-1.5.812 0 1.5.687 1.5 1.5v5.437l8.433-8.437c.562-.625 1.499-.625 2.123 0 .563.562.563 1.5 0 2.062M5.468 32.406l8.434-8.437H8.529c-.874 0-1.499-.625-1.499-1.5 0-.813.625-1.5 1.5-1.5h8.932c.875 0 1.5.687 1.5 1.5v9c0 .875-.625 1.5-1.5 1.5a1.48 1.48 0 0 1-1.499-1.5v-5.375L7.53 34.53c-.562.625-1.5.625-2.061 0-.625-.562-.625-1.5 0-2.125"/>}
        </IconWrapper>);
}
